// extracted by mini-css-extract-plugin
export default {"main":"EssayTextEdit_main__HV1hs","question":"EssayTextEdit_question__0RvFe","tooltip":"EssayTextEdit_tooltip__qUiaB","text_input":"EssayTextEdit_text_input__Q6Sx6"};